<template>
	<div class="card-icon white text-xs-center">
		<img :src="card.icon" :alt="card.alt" height="42">
		<p class="card-icon-text primary--text">
			{{ card.text }}
		</p>
	</div>
</template>

<script>
	export default {
		name: 'card-icon',
		props: {
			card: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.card-icon {
		border-radius: 9px;
		box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.06);
		height: 185px;
		margin: 0 auto 26px;
		padding: 25px 23px;
		width: 198px;

		@media (min-width: 1280px) {
			margin: 0px 13px 15px 0px;
			width: 188px;
		}

		@media (min-width: 1400px) {
			margin: 0px 13px 15px 0px;
			width: 198px;
		}

		&-text {
			margin: 23px 0px 0px;

			@media (min-width: 1280px) {
				font-size: size(small13);
			}

			@media (min-width: 1400px) {
				font-size: size(medium);
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/shared/card-icon.vue